module.exports = __webpack_public_path__ + "img/logoMaquillateWHITE.662b8448.png";